import actionTypes from '../actionTypes/actionTypes';

const DEFAULT_PAGES = 1
const DEFAULT_PAGE_INDEX = 0
const DEFAULT_ROWS = 2
const DEFAULT_COLUMNS = 2
const DEFAULT_DETAILS = true
const DEFAULT_DETAILS_ORIENTATION = 0
const DEFAULT_MODAL = false
const DEFAULT_PREVIEW = false
const DEFAULT_ACTIVE_NAVIGATION = true
const DEFAULT_ACTIVE_NEGATIVE_NAVIGATION = false
const DEFAULT_ACTIVE_PAGE_SELECTION = true
const DEFAULT_ACTIVE_NEGATIVE_PAGE_SELECTION = false
const DEFAULT_SPACING = 1
const DEFAULT_SPACING_MARGIN = false
const DEFAULT_ROW_HEIGHT = 200
const DEFAULT_COLUMN_WIDTH = 200

/* CONTEXT MENU */
const DEFAULT_CONTEXT_MENU_OPEN = false
const DEFAULT_CONTEXT_POS_X = 0
const DEFAULT_CONTEXT_POS_Y = 0
const DEFAULT_CONTEXT_MENU_ORIENTATION_FIXED = false
const DEFAULT_CONTEXT_MENU_ORIENTATION = -1
const DEFAULT_CONTEXT_SUB_MENU_OPEN = false
const DEFAULT_CONTEXT_MENU_DARK_MODE = false
const DEFAULT_CONTEXT_MENU_BORDER = false
const DEFAULT_CONTEXT_MENU_MEDIA = false
const DEFAULT_CONTEXT_MENU_RESIZE = false
const DEFAULT_CONTEXT_MENU_SPLIT = false
const DEFAULT_CONTEXT_MENU_EDIT = false
const DEFAULT_CONTEXT_MENU_ARTICLE = false
const DEFAULT_CONTEXT_MENU_ALIGN = false

/* TEXT CONTEXT MENU */
const DEFAULT_TEXT_CONTEXT_MENU_OPEN = false

export const initialState = {
	preview: DEFAULT_PREVIEW,
	modal: DEFAULT_MODAL,
	details: DEFAULT_DETAILS,
	detailsOrientation: DEFAULT_DETAILS_ORIENTATION,

	contextMenu: {
		open: DEFAULT_CONTEXT_MENU_OPEN,
		subMenuOpen: DEFAULT_CONTEXT_SUB_MENU_OPEN,
		posX: DEFAULT_CONTEXT_POS_X,
		posY: DEFAULT_CONTEXT_POS_Y,
		darkMode: DEFAULT_CONTEXT_MENU_DARK_MODE,
		fixed: DEFAULT_CONTEXT_MENU_ORIENTATION_FIXED,
		orientation: DEFAULT_CONTEXT_MENU_ORIENTATION,
		border: DEFAULT_CONTEXT_MENU_BORDER,
		media: DEFAULT_CONTEXT_MENU_MEDIA,
		resize: DEFAULT_CONTEXT_MENU_RESIZE,
		split: DEFAULT_CONTEXT_MENU_SPLIT,
		edit: DEFAULT_CONTEXT_MENU_EDIT,
		article: DEFAULT_CONTEXT_MENU_ARTICLE,
		align: DEFAULT_CONTEXT_MENU_ALIGN
	},

	textContextMenu: {
		open: DEFAULT_TEXT_CONTEXT_MENU_OPEN,
		subMenuOpen: DEFAULT_CONTEXT_SUB_MENU_OPEN,
		posX: DEFAULT_CONTEXT_POS_X,
		posY: DEFAULT_CONTEXT_POS_Y,
		darkMode: DEFAULT_CONTEXT_MENU_DARK_MODE,
		fixed: DEFAULT_CONTEXT_MENU_ORIENTATION_FIXED,
		orientation: DEFAULT_CONTEXT_MENU_ORIENTATION,
		border: DEFAULT_CONTEXT_MENU_BORDER,
		media: DEFAULT_CONTEXT_MENU_MEDIA,
		resize: DEFAULT_CONTEXT_MENU_RESIZE,
		split: DEFAULT_CONTEXT_MENU_SPLIT,
		edit: DEFAULT_CONTEXT_MENU_EDIT,
		article: DEFAULT_CONTEXT_MENU_ARTICLE,
		align: DEFAULT_CONTEXT_MENU_ALIGN
	},

	info: {
		creationTimestamp: '',
		usedCount: 0,
		updatedTimestamp: '',
		visible: true,
		name: 'TITLE DES BEITRAGS ... LOREM IPSUM DOLOR SIT AMET.',
		id: '',
		internId: '',
		released: false,
		languages: {
			german: false,
			english: false
		},
		pages: DEFAULT_PAGES,
		currentPage: 0,
		previousPage: 0,
		present: false
	},

	/* INFO
		info: [{
			creationTimestamp: string,
			usedCount: integer,
			updatedTimestamp: string,
			visible: boolean,
			id: integer, // Auto Generated ID (Unique)
			released: boolean,
			releasedLanguages: {
				german: boolean,
				english: boolean
			},
			pages
		}]
	*/

	pages: [{
		index: DEFAULT_PAGE_INDEX,
		rows: DEFAULT_ROWS,
		columns: DEFAULT_COLUMNS,
		spacing: DEFAULT_SPACING,
		spacingMargin: DEFAULT_SPACING_MARGIN,
		activeNavigation: DEFAULT_ACTIVE_NAVIGATION,
		activeNegativeNavigation: DEFAULT_ACTIVE_NEGATIVE_NAVIGATION,
		activePageSelection: DEFAULT_ACTIVE_PAGE_SELECTION,
		activeNegativePageSelection: DEFAULT_ACTIVE_NEGATIVE_PAGE_SELECTION,
		height: [{
			row: 0,
			height: DEFAULT_ROW_HEIGHT
		}, {
			row: 1,
			height: DEFAULT_ROW_HEIGHT
		}],

		/*	height: [{
				row: integer,
				height: string | integer, -- string % | integer px
			}]	*/

		width: [{
			column: 0,
			width: DEFAULT_COLUMN_WIDTH
		}, {
			column: 1,
			width: DEFAULT_COLUMN_WIDTH
		}],

		/*	width: [{
				column: integer,
				width: string | integer, -- string % | integer px
			}]	*/

		edit: [],

		/*	edit: [{
				row: integer,
				column: integer
			}]	*/

		preview: [],

		/*	preview: [{
				row: integer,
				column: integer
			}]	*/

		media: [],

		/*	media: [{
				row: integer,
				column: integer,
				type: integer, // -1 = none; 0 = text; 1 = image; 2 = video
				id: string,
				content: {
					link: string, // 1 = image; 2 = video
					autoPlay: boolean, // 2 = video
					origin: string, // 1 = image; 2 = video
					creator: string, // 1 = image; 2 = video
					shiftX: integer, // 1 = image
					shiftY: integer, // 1 = image
					languages: {
						german: string, // 0 = text
						english: string // 0 = text
					}
				}
			}]	*/

		skip: [],

		/*	skip: [{
				row: integer,
				column: integer
			}]	*/

		span: [],

		/*	span: [{
				row: integer,
				column: integer
			}]	*/

		selected: [],

		/*	selected: [{
				row: integer,
				column: integer
			}]	*/

		hovered: [],

		/*	hovered: [{
				row: integer,
				column: integer
			}]	*/

		border: []

		/*	border: [{
				row: integer,
				column: integer,
				all: boolean,
				left: boolean,
				right: boolean,
				top: boolean,
				bottom: boolean
			}]	*/
	}],

	/* PAGES
		pages: [{
			index: integer,
			rows: integer,
			columns: integer,
			spacing: integer,
			spacingMargin: boolean,
			activeNavigation: boolean,
			activePageSelection: boolean,
			height: array,
			width: array,
			edit: array,
			preview: array,
			media: array,
			skip: array,
			span: array,
			selected: array,
			hover: array,
			border: array
		}]
	*/

	skip: [],

	/* SKIP
		skip: [{
			row: integer,
			skip: integer
		}]
	*/

	span: [],

	/* SPAN
		span: [{
			row: integer,
			column: integer,
			colSpan: integer,
			rowSpan: integer
		}]
	*/
}

function articleReducer(state = initialState, action) {
	let newState = state
	let newPage
	let oldPage
	let index = 0
	let pageIndex = 0
	let swapItemSourceIndex = 0
	let swapItemDestinationIndex = 0
	let itemIndex = 0
	let newItem

	// console.log(action)
  
  switch (action.type) {
  	case actionTypes.PAGE_SWAP: /* SWAP */
  		return pageSwap(state, action)
  		break
  	case actionTypes.PAGE_REARRANGE: /* REARRANGE */
  		return pageRearrange(state, action)
  		break
    case actionTypes.CHANGE_CONTEXT_MENU: /* CONTEXT MENU */
    	return changeContextMenu(state, action)
    	break
    case actionTypes.CHANGE_TEXT_CONTEXT_MENU: /* TEXT CONTEXT MENU */
    	return changeTextContextMenu(state, action)
    	break
  	case actionTypes.ADD_HOVERED_CELL: /* HOVERED */
  		return addHoveredCell(state, action)
  		break
  	case actionTypes.REMOVE_HOVERED_CELL:
  		return removeHoveredCell(state, action)
  		break
  	case actionTypes.ADD_EDIT_CELL: /* EDIT */
  		return addEditCell(state, action)
  		break
  	case actionTypes.REMOVE_EDIT_CELL:
  		return removeEditCell(state, action)
  		break
  	case actionTypes.ADD_PREVIEW_CELL: /* PREVIEW */
  		return addPreviewCell(state, action)
  		break
  	case actionTypes.REMOVE_PREVIEW_CELL:
  		return removePreviewCell(state, action)
  		break

  	/* SPACING */
  	case actionTypes.CHANGE_SPACING:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, spacing: action.data.spacing }
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break
  	case actionTypes.CHANGE_SPACING_MARGIN:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, spacingMargin: action.data.spacingMargin }
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* INPUT TEXT */
  	case actionTypes.SET_INPUT_TEXT:
  		state.pages.map((page, pageIndex, array) => {
  			page.index === action.data.index && page.media.map((item, itemIndex, array) => {
  				if (item.row === action.data.row && item.column === action.data.column) {
  					newItem = { 
  						...item, 
  						content: {
  							...item.content,
  							languages: {
  								german: action.data.content.languages.german !== null ? action.data.content.languages.german : item.content.languages.german,
  								english: action.data.content.languages.english !== null ? action.data.content.languages.english : item.content.languages.english
  							}
  						}
  					}
  					newState.pages[pageIndex].media[itemIndex] = newItem
  				}
  			})
  		})

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* SELECTED */
  	case actionTypes.ADD_SELECTED_CELL:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, selected: [ ...page.selected, { row: action.data.row, column: action.data.column }]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.REMOVE_SELECTED_CELL:
  		state.pages.map((page, pIndex, array) => {
  			if (page.index === action.data.index) {
  				page.selected.map((item, iIndex, array) => {
  					if (item.row === action.data.row && item.column === action.data.column) {
  						pageIndex = pIndex
  						itemIndex = iIndex
  					}
  				})
  			}
  		})

	  	newState.pages[pageIndex].selected = [
	  		...newState.pages[pageIndex].selected.slice(0, itemIndex),
	  		...newState.pages[pageIndex].selected.slice(itemIndex + 1)
	  	]

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break
  	case actionTypes.UNSELECT_SELECTED_CELL:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, selected: [] }
  				newState.pages[index] = newPage
  			}
  		})
  		
  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* MEDIA */
  	case actionTypes.ADD_MEDIA:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, media: [ ...page.media, { 
  					row: action.data.row, 
  					column: action.data.column,
  					type: action.data.type,
  					id: action.data.id,
  					content: {
  						link: action.data.content && action.data.content.link || '',
  						origin: action.data.content && action.data.content.origin || '',
  						creator: action.data.content && action.data.content.creator || '',
  						shiftX: 0,
  						shiftY: 0,
  						languages: {
  							german: action.data.content && action.data.content.languages && action.data.content.languages.german || '',
  							english: action.data.content && action.data.content.languages && action.data.content.languages.english || ''
  						}
  					}
  				}]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.UPDATE_MEDIA:
  		console.log(action)

  		let newMedia

  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				page.media.map((item, innerIndex, array) => {
  					if (item.row === action.data.row && item.column === action.data.column) {
  						newMedia = {
  							row: action.data.row, 
		  					column: action.data.column,
		  					type: action.data.type,
		  					id: action.data.id,
		  					content: {
		  						link: action.data.content && action.data.content.link || item.content.link,
		  						autoPlay: action.data.content && action.data.content.autoPlay || item.content.autoPlay,
		  						origin: action.data.content && action.data.content.origin || item.content.origin,
		  						creator: action.data.content && action.data.content.creator || item.content.creator,
		  						shiftX: action.data.content && action.data.content.shiftX || item.content.shiftX,
		  						shiftY: action.data.content && action.data.content.shiftY || item.content.shiftY,
		  						languages: {
		  							german: action.data.content && action.data.content.languages && action.data.content.languages.german || item.content.languages.german,
		  							english: action.data.content && action.data.content.languages && action.data.content.languages.english || item.content.languages.english
		  						}
		  					}
  						}

  						newState.pages[index].media[innerIndex] = newMedia
  					}
  				})
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.REMOVE_MEDIA:
  		state.pages.map((page, pIndex, array) => {
  			if (page.index === action.data.index) {
  				page.media.map((item, iIndex, array) => {
  					if (item.row === action.data.row && item.column === action.data.column) {
  						pageIndex = pIndex
  						itemIndex = iIndex
  					}
  				})
  			}
  		})

	  	newState.pages[pageIndex].media = [
	  		...newState.pages[pageIndex].media.slice(0, itemIndex),
	  		...newState.pages[pageIndex].media.slice(itemIndex + 1)
	  	]

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* PAGE */
  	case actionTypes.ADD_PAGE:
  		return Object.assign({}, state, {
			info: {
				...state.info,
				pages: state.info.pages + 1 
			},
			pages: [
				...state.pages,
				{
					index: state.info.pages,
					rows: DEFAULT_ROWS,
					columns: DEFAULT_COLUMNS,
					activeNavigation: DEFAULT_ACTIVE_NAVIGATION,
					activePageSelection: DEFAULT_ACTIVE_PAGE_SELECTION,
					spacing: DEFAULT_SPACING,
					spacingMargin: DEFAULT_SPACING_MARGIN,
					height: [{
						row: 0,
						height: DEFAULT_ROW_HEIGHT
					}, {
						row: 1,
						height: DEFAULT_ROW_HEIGHT
					}],
					width: [{
						column: 0,
						width: DEFAULT_COLUMN_WIDTH
					}, {
						column: 1,
						width: DEFAULT_COLUMN_WIDTH
					}],
					media: [],
					edit: [],
					preview: [],
					skip: [],
					span: [],
					selected: [],
					hovered: [],
					border: []
				}
			]
		})
  		break
  	case actionTypes.UPDATE_PAGE:
  		return Object.assign({}, state, {
			pages: [
				...state.pages,
				{
					index: state.info.pages,
					rows: DEFAULT_ROWS,
					columns: DEFAULT_COLUMNS
				}
			]
		})
  		break
  	case actionTypes.REMOVE_PAGE:
  		/* return Object.assign({}, state, {
			pages: [
				...state.pages,
				{
					index: state.info.pages,
					rows: DEFAULT_ROWS,
					columns: DEFAULT_COLUMNS
				}
			]
		}) */

		console.log(state)

		/* state.pages.map((page, pIndex, array) => {

			console.log(action.data.index)

  			if (page.index === action.data.index) {
  				console.log(page)

  				page.media.map((item, iIndex, array) => {
  					if (item.row === action.data.row && item.column === action.data.column) {
  						pageIndex = pIndex
  						itemIndex = iIndex
  					}
  				})
  			}
  		}) */

  		// console.log(pageIndex + ' ' + itemIndex)

	  	newState.pages = [
	  		...newState.pages.slice(0, action.data.index),
	  		...newState.pages.slice(action.data.index + 1)
	  	]

	  	newState.pages.map((page, pIndex, array) => {
	  		if (page.index >= action.data.index) {
	  			page.index = page.index - 1
	  		}
	  	})

	  	console.log(newState)

  		return Object.assign({}, state, {
  			info: {
				...state.info,
				pages: state.info.pages - 1 
			},
			pages: newState.pages
		})
  		break
  	case actionTypes.CHANGE_CURRENT_PAGE:
  		return Object.assign({}, state, {
			info: {
				...state.info,
				currentPage: action.data
			}
		})
  		break
  	case actionTypes.CHANGE_PREVIOUS_PAGE:
  		return Object.assign({}, state, {
			info: {
				...state.info,
				previousPage: action.data
			}
		})
  		break

  	/* ROWS */
  	/* INCREASE ROWS */
  	case actionTypes.INCREASE_ROWS:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { 
	  				...page, 
	  				rows: (page.rows + 1),
	  				height: [ ...page.height, { row: page.rows, height: DEFAULT_ROW_HEIGHT }]
  				}

  				itemIndex = index
  			}
  			
  			
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* ADD SELECTED ROW */
  	case actionTypes.ADD_SELECTED_ROW:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				// console.log('ADD_SELECTED_ROW')
  				// console.log(page)
  				// console.log(action)

  				newItem = []

  				for (let i = 0; i < page.columns; i++) {
  					// console.log(i)

					page.selected.map((selected, iSelected, array) => {
						console.log(selected.row + ' ' + selected.column)
						if (selected.row !== action.data.index) {
							console.log('This Row is Inside')
							
						}
					})

					newItem.push({ row: action.data.row, column: i })

  					// console.log(selected.row + ' ' + selected.column)
  					  					
  					// console.log(newItem)
  				}

  				newPage = { ...page, selected: [ ...page.selected, ...newItem ]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.REMOVE_SELECTED_ROW:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				console.log('REMOVE_SELECTED_ROW')
  				// console.log(page)
  				// console.log(action)

  				newItem = []

  				for (let i = 0; i < page.columns; i++) {
  					// console.log(i)

  					page.selected.map((item, iItem, array) => {
  						if (item.row !== action.data.row) {
  							console.log('item: ' + item)
  							newItem.push({ row: action.data.row, column: i })
  						}
  					})

  					// console.log(newItem)
  				}

  				newPage = { ...page, selected: [ ...newItem ]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.DELETE_SELECTED_ROW:
  		/* state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { 
	  				...page, 
	  				rows: (page.columns + 1),
	  				height: [ ...page.height, { row: page.rows, height: DEFAULT_COLUMN_WIDTH }]
	  			}
	  			itemIndex = index
  			}
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		}) */
  		break

  	/* COLUMNS */
  	/* INCREASE COLUMNS */
  	case actionTypes.INCREASE_COLUMNS:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { 
	  				...page, 
	  				columns: (page.columns + 1),
	  				width: [ ...page.width, { column: page.columns, width: DEFAULT_ROW_HEIGHT }]
	  			}
	  			itemIndex = index
  			}
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* ADD SELECTED COLUMN */
  	case actionTypes.ADD_SELECTED_COLUMN:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				// console.log('ADD_SELECTED_COLUMN')
  				// console.log(page)
  				// console.log(action)

  				newItem = []

  				for (let i = 0; i < page.rows; i++) {
  					// console.log(i)

					page.selected.map((selected, iSelected, array) => {
						console.log(selected.row + ' ' + selected.column)
						if (selected.column !== action.data.index) {
							console.log('This Column is Inside')
							
						}
					})

					newItem.push({ row: i, column: action.data.column })

  					// console.log(selected.row + ' ' + selected.column)
  					  					
  					// console.log(newItem)
  				}

  				newPage = { ...page, selected: [ ...page.selected, ...newItem ]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.REMOVE_SELECTED_COLUMN:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				console.log('REMOVE_SELECTED_COLUMN')
  				// console.log(page)
  				// console.log(action)

  				newItem = []

  				for (let i = 0; i < page.rows; i++) {
  					// console.log(i)

  					page.selected.map((item, iItem, array) => {
  						if (item.column !== action.data.column) {
  							console.log('item: ' + item)
  							newItem.push({ row: i, column: action.data.column })
  						}
  					})

  					// console.log(newItem)
  				}

  				newPage = { ...page, selected: [ ...newItem ]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.DELETE_SELECTED_COLUMN:
  		/* state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { 
	  				...page, 
	  				columns: (page.columns + 1),
	  				width: [ ...page.width, { column: page.columns, width: DEFAULT_ROW_HEIGHT }]
	  			}
	  			itemIndex = index
  			}
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		}) */
  		break

  	/* BORDER */
  	case actionTypes.ADD_BORDER:
  		state.pages.map((page, index, array) => {
  			if (page.index === action.data.index) {
  				newPage = { ...page, border: [ ...page.border, { 
  					row: action.data.row, 
  					column: action.data.column,
  					all: action.data.all,
  					top: action.data.top,
  					right: action.data.right,
  					bottom: action.data.bottom,
  					left: action.data.left
  				}]}
  				newState.pages[index] = newPage
  			}
  		})

  		return Object.assign({}, state, {
			pages: newState.pages			
		})
  		break
  	case actionTypes.REMOVE_BORDER:
  		state.pages.map((page, pIndex, array) => {
  			if (page.index === action.data.index) {
  				page.border.map((item, iIndex, array) => {
  					if (item.row === action.data.row && item.column === action.data.column) {
  						pageIndex = pIndex
  						itemIndex = iIndex
  					}
  				})
  			}
  		})

	  	newState.pages[pageIndex].border = [
	  		...newState.pages[pageIndex].border.slice(0, itemIndex),
	  		...newState.pages[pageIndex].border.slice(itemIndex + 1)
	  	]

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* SPAN */
  	case actionTypes.ADD_SPAN:
  		for (let i = 0; i < state.span.length; i++) {
  			if (state.span[i].row === action.data.row && state.span[i].column === action.data.column) {
  				state.span[i].colSpanCount += (action.data.colSpanCount - 1)

  				return Object.assign({}, state, {
					span: [...state.span]
				})
  			}
  		}

  		return Object.assign({}, state, {
			span: [...state.span, action.data]
		})
  		break
  	case actionTypes.REMOVE_SPAN:
  		return Object.assign({}, state, {
			span: [...state.span, action.data]
		})
  		break

  	/* SKIP */
  	case actionTypes.ADD_SKIP:
  		for (let i = 0; i < state.skip.length; i++) {
  			if (state.skip[i].row === action.data.row && state.skip[i].column === action.data.column) {
  				state.skip[i].skip += action.data.skip

  				return Object.assign({}, state, {
					skip: [...state.skip]
				})
  			}
  		}

  		return Object.assign({}, state, {
			skip: [...state.skip, action.data]
		})
  		break
  	case actionTypes.REMOVE_SKIP:
  		return Object.assign({}, state, {
			skip: [...state.skip, action.data]
		})
  		break

  	/* WIDTH */
  	case actionTypes.SET_WIDTH:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index && page.width.map((item, index, array) => {
  				item.column === action.data.column ? item.width = action.data.width : null
  			})
  		})

		return state
  		break

  	/* HEIGHT */
  	case actionTypes.SET_HEIGHT:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index && page.height.map((item, index, array) => {
  				item.row === action.data.row ? item.height = action.data.height : null
  			})
  		})

		return state
  		break

  	/* MODAL */
  	case actionTypes.CHANGE_MODAL:
  		return Object.assign({}, state, {
			modal: action.data.modal
		})
  		break

  	/* TABLE PAGE SELECTION */
  	case actionTypes.CHANGE_TABLE_PAGE_SELECTION:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index ? newPage = { ...page, activePageSelection: action.data.activePageSelection } : null
  			page.index === action.data.index ? itemIndex = index : null
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* TABLE NEGATIVE PAGE SELECTION */
  	case actionTypes.CHANGE_TABLE_NEGATIVE_PAGE_SELECTION:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index ? newPage = { ...page, activeNegativePageSelection: action.data.activeNegativePageSelection } : null
  			page.index === action.data.index ? itemIndex = index : null
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* TABLE NAVIGATION */
  	case actionTypes.CHANGE_TABLE_NAVIGATION:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index ? newPage = { ...page, activeNavigation: action.data.activeNavigation } : null
  			page.index === action.data.index ? itemIndex = index : null
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* TABLE NEGATIVE NAVIGATION */
  	case actionTypes.CHANGE_TABLE_NEGATIVE_NAVIGATION:
  		state.pages.map((page, index, array) => {
  			page.index === action.data.index ? newPage = { ...page, activeNegativeNavigation: action.data.activeNegativeNavigation } : null
  			page.index === action.data.index ? itemIndex = index : null
  		})

  		newState.pages[itemIndex] = newPage

  		return Object.assign({}, state, {
			pages: newState.pages
		})
  		break

  	/* DETAILS */
  	case actionTypes.CHANGE_DETAILS:
  		return Object.assign({}, state, {
			details: action.data.details
		})
  		break
  	case actionTypes.CHANGE_DETAILS_ORIENTATION:
  		return Object.assign({}, state, {
			detailsOrientation: action.data.detailsOrientation
		})
  		break

  	/* PREVIEW */
  	case actionTypes.CHANGE_PREVIEW:
  		return Object.assign({}, state, {
			preview: action.data.preview
		})
  		break

  	/* NEW TEMPLATE */
  	case actionTypes.NEW_TEMPLATE:
  		return Object.assign({}, state, {
  			...state,
  			activeNavigation: DEFAULT_ACTIVE_NAVIGATION,
			activePageSelection: DEFAULT_ACTIVE_PAGE_SELECTION,
			preview: DEFAULT_PREVIEW,
			modal: DEFAULT_MODAL,

			rows: DEFAULT_ROWS,
			columns: DEFAULT_COLUMNS
  		})
  		break

  	/* DEFAULT */
    default:
		return state
  }
}

function pageSwap(state, action) {
	let itemIndex
	let newState = state
	let swapItemSourceIndex
	let swapItemDestinationIndex

	state.pages.map((page, index, array) => {
		page.index === action.data.source ? swapItemSourceIndex = page.index : null
		page.index === action.data.destination ? swapItemDestinationIndex = page.index : null
	})

	itemIndex = newState.pages[swapItemSourceIndex].index
	newState.pages[swapItemSourceIndex].index = newState.pages[swapItemDestinationIndex].index
	newState.pages[swapItemDestinationIndex].index = itemIndex

	return Object.assign({}, state, {
		pages: newState.pages
	})
}

function pageRearrange(state, action) {
	return Object.assign({}, state, {
		pages: ''
	})
}

function changeContextMenu(state, action) {
	return Object.assign({}, state, {
		contextMenu: {
			open: action.data.open !== undefined ? action.data.open : state.contextMenu.open,
			subMenuOpen: action.data.subMenuOpen !== undefined ? action.data.subMenuOpen : state.contextMenu.subMenuOpen,
			posX: action.data.posX !== undefined  ? action.data.posX : state.contextMenu.posX,
			posY: action.data.posY !== undefined  ? action.data.posY : state.contextMenu.posY,
			darkMode: action.data.darkMode !== undefined ? action.data.darkMode : state.contextMenu.darkMode,
			fixed: action.data.fixed !== undefined ? action.data.fixed : state.contextMenu.fixed,
			orientation: action.data.orientation !== undefined ? action.data.orientation : state.contextMenu.orientation,
			border: action.data.border !== undefined ? action.data.border : state.contextMenu.border,
			media: action.data.media !== undefined ? action.data.media : state.contextMenu.media,
			resize: action.data.resize !== undefined ? action.data.resize : state.contextMenu.resize,
			split: action.data.split !== undefined ? action.data.split : state.contextMenu.split,
			edit: action.data.edit !== undefined ? action.data.edit : state.contextMenu.edit,
			article: action.data.article !== undefined ? action.data.article : state.contextMenu.article,
			align: action.data.align !== undefined ? action.data.align : state.contextMenu.align
		}
	})
}

function changeTextContextMenu(state, action) {
	return Object.assign({}, state, {
		textContextMenu: {
			open: action.data.open !== undefined ? action.data.open : state.textContextMenu.open,
			subMenuOpen: action.data.subMenuOpen !== undefined ? action.data.subMenuOpen : state.textContextMenu.subMenuOpen,
			posX: action.data.posX !== undefined  ? action.data.posX : state.textContextMenu.posX,
			posY: action.data.posY !== undefined  ? action.data.posY : state.textContextMenu.posY,
			darkMode: action.data.darkMode !== undefined ? action.data.darkMode : state.textContextMenu.darkMode,
			fixed: action.data.fixed !== undefined ? action.data.fixed : state.textContextMenu.fixed,
			orientation: action.data.orientation !== undefined ? action.data.orientation : state.textContextMenu.orientation,
			border: action.data.border !== undefined ? action.data.border : state.textContextMenu.border,
			media: action.data.media !== undefined ? action.data.media : state.textContextMenu.media,
			resize: action.data.resize !== undefined ? action.data.resize : state.textContextMenu.resize,
			split: action.data.split !== undefined ? action.data.split : state.textContextMenu.split,
			edit: action.data.edit !== undefined ? action.data.edit : state.textContextMenu.edit,
			article: action.data.article !== undefined ? action.data.article : state.textContextMenu.article,
			align: action.data.align !== undefined ? action.data.align : state.textContextMenu.align
		}
	})
}

function addHoveredCell(state, action) {
	let newState = state
	let newPage

	state.pages.map((page, index, array) => {
		if (page.index === action.data.index) {
			newPage = { ...page, hovered: [{ row: action.data.row, column: action.data.column }]}
			newState.pages[index] = newPage
		}
	})

	return Object.assign({}, state, {
		pages: newState.pages			
	})
}

function removeHoveredCell(state, action) {
	let newState = state
	let pageIndex
	let itemIndex

	state.pages.map((page, pIndex, array) => {
		if (page.index === action.data.index) {
			page.hovered.map((item, iIndex, array) => {
				if (item.row === action.data.row && item.column === action.data.column) {
					pageIndex = pIndex
					itemIndex = iIndex
				}
			})
		}
	})

	newState.pages[pageIndex].hovered = [
		...newState.pages[pageIndex].hovered.slice(0, itemIndex),
		...newState.pages[pageIndex].hovered.slice(itemIndex + 1)
	]

	return Object.assign({}, state, {
		pages: newState.pages
	})
}

function addEditCell(state, action) {
	let newState = state
	let newPage

	state.pages.map((page, index, array) => {
		if (page.index === action.data.index) {
			newPage = { ...page, edit: [ ...page.edit, { row: action.data.row, column: action.data.column }]}
			newState.pages[index] = newPage
		}
	})

	return Object.assign({}, state, {
		pages: newState.pages			
	})
}

function removeEditCell(state, action) {
	let newState = state
	let pageIndex
	let itemIndex

	state.pages.map((page, pIndex, array) => {
		if (page.index === action.data.index) {
			page.edit.map((item, iIndex, array) => {
				if (item.row === action.data.row && item.column === action.data.column) {
					pageIndex = pIndex
					itemIndex = iIndex
				}
			})
		}
	})

	newState.pages[pageIndex].edit = [
		...newState.pages[pageIndex].edit.slice(0, itemIndex),
		...newState.pages[pageIndex].edit.slice(itemIndex + 1)
	]

	return Object.assign({}, state, {
		pages: newState.pages
	})
}

function addPreviewCell(state, action) {
	let newState = state
	let newPage

	state.pages.map((page, index, array) => {
		if (page.index === action.data.index) {
			newPage = { ...page, preview: [ ...page.preview, { row: action.data.row, column: action.data.column }]}
			newState.pages[index] = newPage
		}
	})

	return Object.assign({}, state, {
		pages: newState.pages			
	})
}

function removePreviewCell(state, action) {
	let newState = state
	let pageIndex
	let itemIndex
	
	state.pages.map((page, pIndex, array) => {
		if (page.index === action.data.index) {
			page.preview.map((item, iIndex, array) => {
				if (item.row === action.data.row && item.column === action.data.column) {
					pageIndex = pIndex
					itemIndex = iIndex
				}
			})
		}
	})

	newState.pages[pageIndex].preview = [
		...newState.pages[pageIndex].preview.slice(0, itemIndex),
		...newState.pages[pageIndex].preview.slice(itemIndex + 1)
	]

	return Object.assign({}, state, {
		pages: newState.pages
	})
}

export default articleReducer;